import React, { createContext, useContext } from 'react'
import { useAuth } from '../hooks'

const AuthContext = createContext(null)

/**
 * Провайдер аутентификации
 */
export const AuthProvider = ({ children }) => {
    const auth = useAuth()

    return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}

/**
 * Хук для использования контекста аутентификации
 */
export const useAuthContext = () => {
    const context = useContext(AuthContext)

    if (!context) {
        throw new Error('useAuthContext must be used within an AuthProvider')
    }

    return context
}
